import { useEffect } from "react";
import { useRouteContext, useRouter } from "@tanstack/react-router";
import { CustomerIO } from "@repo/customerio-plugin";
import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { iosOrAndroid, VITE_CUSTOMER_IO_API_KEY } from "@/lib/utils/config";

interface CustomerIOEvent {
  type: string;
  detail: {
    actionName: string;
    actionValue: string;
  };
}

export const usePushNotificationPrompt = (): void => {
  const router = useRouter();

  const { user } = useRouteContext({ from: "__root__" });
  const { codUsuario, email = "" } = user;

  useEffect(() => {
    if (!codUsuario || codUsuario === 0) {
      return;
    }

    if (iosOrAndroid) {
      CustomerIO.requestPushNotificationsPermission();

      CustomerIO.identify({ identifier: codUsuario.toString(), email });
    }

    if (VITE_CUSTOMER_IO_API_KEY) {
      const handleCustomerIoAction = (event: CustomerIOEvent): void => {
        if (event.detail.actionName === "navigate") {
          void router.navigate({ to: event.detail.actionValue });
        }
      };

      const cioAnalytics = AnalyticsBrowser.load(
        {
          writeKey: String(VITE_CUSTOMER_IO_API_KEY),
        },
        {
          integrations: {
            "Customer.io In-App Plugin": {
              // @ts-expect-error -- a tipagem está errada
              events: (event: CustomerIOEvent): void => {
                switch (event.type) {
                  case "in-app:message-opened":
                    // quando visualiza um in-app
                    break;
                  case "in-app:message-dismissed":
                    // quando fecha um in-app
                    break;
                  case "in-app:message-action":
                    handleCustomerIoAction(event);
                    break;
                  case "in-app:message-error":
                    // quando um in-app falha
                    break;
                  case "in-app:message-changed":
                    // quando um in-app de muitas etapas muda de etapa
                    break;
                }
              },
            },
          },
        },
      );

      void cioAnalytics.identify(codUsuario.toString(), {
        email,
      });
    }
  }, [codUsuario, email, router]);
};
